export const compressImage = (
  file: File,
  maxSizeMB: number = 2,
  maxWidth: number = 1920
): Promise<File> => {
  return new Promise((resolve, reject) => {
    const maxBytes = maxSizeMB * 1024 * 1024;

    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target?.result as string;

      img.onload = async () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        // 🔥 STEP 1: Resize if too large
        let width = img.width;
        let height = img.height;

        if (width > maxWidth) {
          height = (maxWidth / width) * height;
          width = maxWidth;
        }

        canvas.width = width;
        canvas.height = height;
        ctx?.drawImage(img, 0, 0, width, height);

        let quality = 0.8;

        const compress = (q: number): Promise<Blob> =>
          new Promise((resolveBlob) =>
            canvas.toBlob(
              (blob) => resolveBlob(blob as Blob),
              "image/jpeg", // 🔥 force JPEG for better compression
              q
            )
          );

        let blob = await compress(quality);

        // 🔥 STEP 2: Reduce quality gradually
        while (blob.size > maxBytes && quality > 0.1) {
          quality -= 0.1;
          blob = await compress(quality);
        }

        if (blob.size > maxBytes) {
          return reject("Unable to compress below required size.");
        }

        resolve(new File([blob], file.name, { type: "image/jpeg" }));
      };
    };

    reader.onerror = (err) => reject(err);
  });
};
